import * as React from 'react';
export var BreakpointContext = React.createContext();
export var defaultBreakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

var Breakpoints = function Breakpoints(_ref) {
  var _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? defaultBreakpoints : _ref$breakpoints,
      children = _ref.children;
  return React.createElement(BreakpointContext.Provider, {
    value: breakpoints
  }, children);
};

export default Breakpoints;